let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8eCH0")).then(() => parcelRequire('io0Lo'));